__turbopack_context__.v({
  "className": "interfont_f2862180-module__Gnis7G__className",
  "variable": "interfont_f2862180-module__Gnis7G__variable",
});
